import { z } from "zod";
import { NonEmptyMessage } from "../../../../../common/utils/form_validation_messages";

/**
 * Custom validation
 */

const validateCPF = (x: string | null) => {
  if (x === null) return true;
  const requiredFullSize = 'xxxxxxxxxxx'.length;
  const normalized = x.replaceAll(/\D/g, '');

  if (normalized.length === 0) {
    return true;
  }
  if (normalized.length !== requiredFullSize) {
    return false;
  }

  let soma = 0;
  let peso = 10;

  for (let i = 0; i < 9; i++) {
    soma += parseInt(normalized[i]) * peso;
    peso--;
  }

  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  if (resto !== parseInt(normalized[9])) {
    return false;
  }

  soma = 0;
  peso = 11;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(normalized[i]) * peso;
    peso--;
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  if (resto !== parseInt(normalized[10])) {
    return false;
  }
  return true;
}

/**
 * DependenteSchema
 */

export const DependenteSchema = z.object({
  nome: z.string().nonempty({ message: NonEmptyMessage }),
  grauParentesco: z.string().default(""),
  rg: z.string().default(""),
  cpf: z.string().default("").refine(validateCPF, { message: "CPF Invalido!" }),
  dataNascimento: z.coerce.date().nullable().default(null),
});

/**
 * DependenteForm
 */

export type DependenteForm = z.infer<typeof DependenteSchema>;